const translations = {
    acreage: '{value} acres',
    acres: 'Acres',
    activeIngredients: 'Active Ingredients',
    addBoundary: 'Add Boundary',
    addChemical: '+ Add Chemical',
    addItem: '+ Add Item',
    addNewCustomer: '+ Add a new customer',
    addNewSite: '+ Add a new site',
    addSite: '+ Add Another Site',
    address: 'Address',
    all: 'All',
    applicationDetails: 'Application',
    applicationMethod: 'Method',
    applicationMethodAir: 'Air',
    applicationMethodGround: 'Ground',
    applicationRate: 'Application Rate',
    applicationSites: 'Application Sites',
    applicator: 'Applicator',
    appliedAcres: 'Applied Acres',
    assignSitesAfterSave: 'Save to assign sites',
    awaitingConfirmation: 'Awaiting confirmation',
    backToWorkOrders: 'Back to work orders',
    calendar: 'Calendar',
    calendarLegend: 'Legend',
    cancel: 'Cancel',
    canceled: 'Canceled',
    chemical: 'Chemical',
    chemicalCost: 'Chemical Cost',
    chemicals: 'Chemicals',
    city: 'City',
    commodity: 'Commodity',
    commodityChemicalRequired: 'Select a chemical first',
    commodityChemicalRequiredNote:
        'Select a chemical below before choosing a commodity. The crop list comes from the chemicals’ label data, so there is nothing to offer until one is added.',
    commodityCropCleared:
        '{{cropName}} was cleared because none of the selected products is labelled for it. Pick another commodity.',
    commodityCropClearedNoCrops:
        '{{cropName}} was cleared because the selected products have no crops on file.',
    commodityLoadingCrops: 'Loading crops…',
    commodityNoCropScenarios:
        'No crops on file for the selected chemicals. Enter the commodity by hand.',
    commodityNoMatchingCrops: 'No matching crops',
    commodityNotOnLabel: 'Not on the selected product labels.',
    commodityRestrictionsUnavailable:
        'Label restrictions could not be loaded for the selected chemicals. Enter the commodity by hand.',
    commoditySelectPlaceholder: 'Select a commodity',
    commodityTextPlaceholder: 'Enter a commodity',
    company: 'Company',
    complete: 'Complete',
    completeJob: 'Complete',
    completed: 'Completed',
    contact: 'Contact',
    continueLabel: 'Continue',
    createInvoice: 'Create Invoice',
    createProductUsageReport: 'Create Product Usage Report',
    customer: 'Customer',
    defaultWorkOrderName: 'WO #{{number}}',
    deleteConfirm: 'Are you sure you want to delete this work order? This cannot be undone.',
    deleteError: 'Failed to delete work order. Please try again.',
    deleteWorkOrder: 'Delete work order',
    details: 'Details',
    discardCancel: 'Keep editing',
    discardConfirm: 'Discard',
    discardMessage: 'You have unsaved changes in this work order. Discard them?',
    discardTitle: 'Discard changes?',
    done: 'Done',
    downloadJobEstimate: 'Job Estimate',
    downloadWorkOrderPdf: 'Work Order PDF',
    drawerTitle: 'Work Order Details',
    duplicateWorkOrder: 'Duplicate Work Order',
    edit: 'Edit',
    editBoundary: 'Edit Boundary',
    emptyStateAction: 'Create Work Order',
    emptyStateHeading: 'Let\u2019s get started by adding a work order',
    epaNumber: 'EPA Number',
    estimate: 'Estimate',
    estimatedTotal: 'Estimated Total',
    expirationDate: 'Expiration Date',
    expirationDateBeforeProposedError:
        'Expiration date must be on or after the proposed date. Please adjust the dates.',
    fetchError: 'Failed to fetch work orders',
    fieldApplicationFlatFee: 'Field Application Flat Fee',
    fieldApplicationRate: 'Field Application Rate',
    fieldName: 'Field Name',
    fieldSize: 'Field Size',
    filterCompleted: 'Completed',
    filterPending: 'Pending',
    filterScheduled: 'Scheduled',
    filterStarted: 'Started',
    grower: 'Grower',
    growerInformation: 'Grower Information',
    growthStage: 'Growth Stage',
    hoursWorked: 'Hours Worked',
    inProgress: 'In progress',
    invoiceItemAmount: 'Amount',
    invoiceItemDescription: 'Description',
    invoiceItems: 'Invoice Items',
    jobCompleted: 'Completed',
    labelIntervalCommodityNotOnLabels: "{{cropName}} isn't on any label in this mix",
    labelIntervalDays_one: '{{count}} day',
    labelIntervalDays_other: '{{count}} days',
    labelIntervalDaysAndHours: '{{days}}, {{hours}}',
    labelIntervalHours_one: '{{count}} hour',
    labelIntervalHours_other: '{{count}} hours',
    labelIntervalLabelsFailed: "Couldn't load the labels — try again",
    labelIntervalLeftOut:
        "{{productName}}'s label has no directions for {{cropName}}, so its wait isn't included",
    labelIntervalLoading: 'Reading the labels…',
    labelIntervalMostRestrictive: '— most restrictive, from {{productName}}',
    labelIntervalNoLabelData: 'No label data for {{productName}}',
    labelIntervalNoScenariosForMethod:
        "{{productName}}'s label has no directions for {{cropName}} by this method",
    labelIntervalNotAllowed:
        'Not allowed on the {{productName}} label for {{cropName}} in {{stateName}}',
    labelIntervalNotAllowedAllStates: 'Not allowed on the {{productName}} label for {{cropName}}',
    labelIntervalNotQuantifiable: 'Not quantifiable — see label',
    labelIntervalNotSpecified: 'Not specified on any label in this mix',
    labelIntervalPending: 'Fills in from the labels once a product and commodity are picked',
    labelIntervalScenario: '{{productName}} · {{cropName}} · {{stateName}}',
    labelIntervalScenarioAllStates: '{{productName}} · {{cropName}} · All states',
    labelsFailedSaveMessage:
        "Couldn't load the chemical labels. Try again on the Chemicals tab to save.",
    labelsLoadingSaveMessage: 'Reading the chemical labels before saving…',
    latitude: 'Latitude',
    legendActive: 'Active',
    legendComplete: 'Complete',
    legendPending: 'Pending',
    loadingMessage: 'One moment while we get your list of Work Orders',
    location: 'Location',
    locationUnavailableError:
        'Unable to access your current location. Check your device permissions and try again.',
    longitude: 'Longitude',
    map: 'Map',
    mixIntervals: 'Mix intervals · most restrictive product',
    moreActions: 'More actions',
    multipleBoundaryError:
        'Only one boundary is allowed per site. Delete the extra shapes before continuing.',
    newWorkOrder: 'New',
    noChemicals: 'No chemicals assigned',
    noDate: 'No Date',
    noNotesMessage: 'No notes added',
    noSites: 'No sites assigned',
    noSitesHint: 'No sites have been added to this work order.',
    noWorkOrders: 'No work orders found',
    noWorkOrdersHint: 'Create a new work order to get started.',
    notSet: 'Not set',
    notes: 'Notes',
    orphanedSitesWarning:
        'One or more sites in this work order have been archived and removed automatically.',
    past: 'Past',
    pending: 'Pending',
    percentageUnit: '%',
    pest: 'Pest',
    phone: 'Phone',
    preHarvestInterval: 'Pre-Harvest Interval',
    product: 'Product',
    productUsageReportWarning:
        'A product usage report exists for this work order. You may only edit the status option or Job Estimate page',
    products: '{count} products',
    proposedAcres: 'Proposed Acres',
    proposedDate: 'Proposed Date',
    rate: 'Rate',
    reEntryInterval: 'Re-Entry Interval',
    removeSite: 'Remove site',
    requiredFieldsError: 'Please fill in all required fields before saving',
    sameAsCustomer: 'Same as customer',
    save: 'Save',
    saveErrorMessage: 'Failed to save work order. Please try again.',
    saving: 'Saving…',
    scheduled: 'Scheduled',
    searchWorkOrders: 'Search work orders…',
    selectApplicator: 'Select team member',
    selectStatus: 'Select status',
    signalWord: 'Signal Word',
    site: '{count} site',
    siteAddressWithoutCoordinatesError:
        'Each site needs a location. Please use the map to set coordinates or draw a boundary, or remove sites without a location.',
    siteCommodity: 'Site Commodity',
    siteTab: 'Site',
    sites: '{count} sites',
    startJob: 'Start Job',
    started: 'Started',
    state: 'State',
    statsSeparator: ' \u00B7 ',
    status: 'Status',
    targetSprayRate: 'Target Spray Rate',
    taxAmount: 'Tax Amount',
    time: 'Time',
    total: 'Total',
    tryLabelsAgain: 'Try again',
    unitAcres: 'Ac',
    unitDays: 'Days',
    unitFluidOuncesPerAcre: 'Fl. Oz/Ac',
    unitGallonsPerAcre: 'Ga/Ac',
    unitHectares: 'Ha',
    unitHours: 'Hours',
    unitKilogramsPerSquareMeter: 'Kg/m²',
    unitLitersPerHectare: 'L/Ha',
    unitOuncesPerAcre: 'Oz/Ac',
    unitPerAcre: '$ / Ac',
    unitPerHour: '$ / Hr',
    unitPintsPerAcre: 'Pt/Ac',
    unitPoundsPerAcre: 'Lb/Ac',
    unitQuartsPerAcre: 'Qt/Ac',
    unitUsd: 'USD',
    upcoming: 'Upcoming',
    workOrderDetails: 'Work Order Details',
    workOrderName: 'Work order name',
    workOrders: 'Work Orders',
    zipCode: 'Zip Code'
};

export default translations;
